import { KYMW1300Model } from '../kymw1300.model';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画メンテアップロードファイルの取込要求を行う
 *
 * @export
 * @class UploadPlanGoodsCoopFileService
 * @extends {PlessUploadServiceSub}
 */
@Injectable()
export class UploadPlanGoodsCoopFileService extends PlessJsonUploadServiceSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof UploadPlanGoodsCoopFileService
   */
  private model: KYMW1300Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof UploadPlanGoodsCoopFileService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param {*} model
   * @param {File} file
   * @param {Function} successFunc
   * @memberof UploadPlanGoodsCoopFileService
   */
  execute(model: any, file: File, successFunc: Function): void {
    this.model = <KYMW1300Model> model;
    this.successFunc = successFunc;
    this.sendFile('uploadPlanGoodsCopeFile', new PlessRequest(), file);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UploadPlanGoodsCoopFileService
   */
  success(data: any) {
    this.successFunc(data);
  }
}
